import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/busPickup'

//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

export const busPickupService = {
    saveItem,
    updateItem,
    deleteItem,
    search,
    translate
};
